import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import TrustBar from "@/pages/home/components/TrustBar";
import Programs from "@/pages/home/components/Programs";
import Included from "@/pages/home/components/Included";
import Path from "@/pages/home/components/Path";
import Outcomes from "@/pages/home/components/Outcomes";
import Testimonials from "@/pages/home/components/Testimonials";
import FAQ from "@/pages/home/components/FAQ";
import CTA from "@/pages/home/components/CTA";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <main className="bg-background-50 text-foreground-900">
      <Navbar />
      <Hero />
      <TrustBar />
      <Programs />
      <Included />
      <Path />
      <Outcomes />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
    </main>
  );
}